export default __webpack_public_path__ + "static/media/gallery - cover_05.48d20b95.jpg";